import {
  UserProfileUpdatePasswordData,
} from '../../model/user-profile';
import {
  IUserUpdateProfilePasswordDto,
} from '../dto/user-profile.dto';

export function toUserProfileUpdatePasswordDtoMapper(
  password: UserProfileUpdatePasswordData
): IUserUpdateProfilePasswordDto {
  return {
    oldPassword: password.oldPassword,
    newPassword: password.newPassword,
    confirmPassword: password.confirmPassword,
  };
}
